import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Datepicker from "components/Input/Datepicker/Datepicker";
import s from "./CreateContent.module.scss";

const CreateContent = ({ handleInput }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const transDateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
      ? ""
      : null;
    if (type === "start") {
      handleInput(date, "transDate");
    }
  };
  const transDateOnFocus = () => {
    setFocus({ transDate: true });
  };
  const transDateOnBlur = () => {
    setFocus({ transDate: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <Datepicker
          label={t(
            "page.finance.reconciliation.by.transaction.date.create.function.dialog.content.1",
          )}
          mandatory
          type="start"
          noErrorMessage
          onchangeFn={transDateOnChange}
          onfocusFn={transDateOnFocus}
          onblurFn={transDateOnBlur}
          sxParams={{ datepickerFocus: focus.transDate }}
        />
      </div>
    </div>
  );
};

export default React.memo(CreateContent);
